import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class PayTransactionVNPService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    // receiveTransaction(payTransactionVNP: any) {
    //     return this.http.post(this.BaseURI + '/PayTransactionVNP/ReceiveTransaction', payTransactionVNP);
    // }

    getListFilterUser() {
        return this.http.get(this.BaseURI + '/PayTransactionVNP/ListFilterUser');
    }

    getListTransRecharge(params: any) {
        return this.http.get(this.BaseURI + '/PayTransactionVNP/ListTransRecharge', {
            params: params,
        });
    }

    getListFilterProject() {
        return this.http.get(this.BaseURI + '/PayTransactionVNP/ListFilterProject');
    }

    getListTransRetail(params: any) {
        return this.http.get(this.BaseURI + '/PayTransactionVNP/ListTransRetail', {
            params: params,
        });
    }
}